import { VideoTracking } from "_fil_local_addon/camc-cms-video/camc-cms-video-tracking";

document.addEventListener("DOMContentLoaded", function () {
    $(".media-block-local-video").on("play", function (event) {
        try {
            // local video tracking do not need eventContent field
            const eventContent = "";
            const clickedElement = event.currentTarget;
            const videoLink = clickedElement.querySelector("source").src || "";
            const eventCategory = "local";
            const title = clickedElement.getAttribute("data-title") || "";
            VideoTracking.trackingVideoEvent(videoLink, eventCategory, title, eventContent);
            $(event.currentTarget).off("play");
        } catch (error) {
            console.log("camc media block local video tracking error");
        }
    });

    $(".youku__item").on("click.youkuVideoTracking", function (event) {
        try {
            const clickedElement = event.currentTarget;
            if (clickedElement.classList.contains("youku__item--error")) {
                return;
            }
            const videoLink = clickedElement.getAttribute("data-url") || "";
            const eventCategory = "youku";
            const title = clickedElement.getAttribute("data-title") || "";
            const eventContent = clickedElement.getAttribute("data-video-id") || "";
            VideoTracking.trackingVideoEvent(videoLink, eventCategory, title, eventContent);
            $(event.currentTarget).off("click.youkuVideoTracking");
        } catch (error) {
            console.log("camc media block youku video tracking error");
        }
    });
});
